export default __webpack_public_path__ + "329c5ff16cf344a462db418ac0b595d7.svg";